import {
	Component,
	HostBinding,
	EventEmitter,
	Input,
	OnInit,
	Output, ChangeDetectionStrategy, ChangeDetectorRef
} from "@angular/core";

import * as moment from "moment";

import {
	CalendarView
} from '@progress/kendo-angular-dateinputs';

import {DateMode} from "../../services/date.helper.service";
import {SystemConfigurationValues} from "../../../configuration/services/system.configuration.utils";
import {HijriDateService} from "../../services/hijri.date.service";

@Component({
	selector:'cp-calendar',
	templateUrl:'./custom.calendar.template.html',
	styleUrls: ['./custom.calendar.style.scss'],
	// cannot support on push since we're using templating which are not affected by inputs and need to run again
	//changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCalendarComponent  implements OnInit{
	@Input() showNavigationArrows:Boolean = true;
	@Input() date:Date;
	@Input() markerFunction: any;
	@Input() min: Date;
	@Input() max: Date;
	@Input() dateMode: DateMode = DateMode.Default;
	@Input() showHijri: boolean = false;

	@Output() dateChange = new EventEmitter<Date>();
	@Output() activeViewChange = new EventEmitter<void>();

	@HostBinding('class') dateModeClass: DateMode = DateMode.Default;
	@HostBinding('class.show-arrows') showArrows: Boolean = true;

	public activeDate:Date;
	public activeView: CalendarView = "month";
	public showHijriDate: boolean = false;

	constructor(private cd:ChangeDetectorRef, private systemConfiguration: SystemConfigurationValues, public hijriDateService: HijriDateService) {
		this.showHijriDate = this.systemConfiguration.getBoolean('ActivateIslamicCalendar',false);
	}

	ngOnInit(): void {
		this.activeDate = this.date;
		this.dateModeClass = this.dateMode;
		this.showArrows = this.showNavigationArrows;
	}

	public redrawWorkroundOutOfDom(){
		//https://github.com/telerik/kendo-angular/issues/993
		this.activeDate = new Date(this.activeDate);
		this.cd.markForCheck();
	}
	/*
	* Update focused date:
	* set focused date one previous (negative number)/next (positive number) month
	* */
	public updateFocusedDate(value: number) {
		this.updateDates(value);
	}

	public onActiveDateChange(value: Date): void {
		if (value) {
			this.activeDate = value;
		}
	}

	public onActiveViewChange(event){
		this.activeView = event;
		// added to prevent calendar from closing when passing to more specific view (year -> month) in mav
		this.activeViewChange.emit();
	}

	public displayPrevArrow(): boolean {
		return !(this.min && this.activeDate && moment(this.activeDate).isSame(this.min, 'month'));
	}

	public displayNextArrow(): boolean {
		return !(this.max && this.activeDate && moment(this.activeDate).isSame(this.max, 'month'));
	}

	private updateDates(interval:number){
		this.activeDate = moment(this.activeDate).add( interval, "month").toDate();
	}

	updateData() {
		if(this.showHijri && this.showHijriDate) {
			switch (this.activeView) {
				case "month":
					this.hijriDateService.getHijriDatesInMonth(this.activeDate);
					break;
				case "year":
					this.hijriDateService.getHijriDatesInYear(this.activeDate);
					break;
				case "decade":
					this.hijriDateService.getHijriDatesInDecade(this.activeDate);
					break;
				case "century":
					break;
			}
		}
	}
}
